(function(){
  'use strict';
  if(window.EBCartV2||window.EnochCartV2) return;

  /* Funnel-aware deterministic cart controller (2026-07-28).
     The shared drawer remains the renderer. This module exclusively owns cart writes on all three
     purchase funnels so rapid remove/add reversals become one latest-state correction instead of
     overlapping Shopify requests. The historical asset/global names stay as compatibility aliases. */
  var V1=57973361377628,V2=57973361410396,V3=57973361443164;
  var TIER={};TIER[V1]=1;TIER[V2]=2;TIER[V3]=3;
  var BUMP88=57973362360668,COMP4=58077303963996,PROTECT=58077497950556;
  var B_LIB=57809363403100,B_ENO_AUD=57973362458972,B_ENO_EB=58077977084252;
  var B_ALL5_AUD=57809363468636,B_ALL5_EB=57809363435868,B_88=57973362491740,B_SHIP=57811037323612;
  var B_88_EB=58111419679068,B_88_AUD=58111430328668;
  var BONUSES=[B_LIB,B_ENO_AUD,B_ENO_EB,B_ALL5_AUD,B_ALL5_EB,B_88,B_88_EB,B_88_AUD,B_SHIP];
  /* Shopify displays newly batch-added cart lines in reverse request order. Keep this list in the
     exact order customers should read the complimentary portion of checkout. Shipping is always
     first; the remaining gifts are stable across all three funnels. */
  var FREE_CHECKOUT_ORDER=[B_SHIP,B_LIB,B_ALL5_AUD,B_ALL5_EB,B_88,B_88_AUD,B_88_EB,B_ENO_AUD,B_ENO_EB];
  var FREESHIP={US:1,GB:1,CA:1,AU:1,AT:1,BE:1,BG:1,HR:1,CY:1,CZ:1,DK:1,EE:1,FI:1,FR:1,DE:1,GR:1,HU:1,IE:1,IT:1,LV:1,LT:1,LU:1,MT:1,NL:1,PL:1,PT:1,RO:1,SK:1,SI:1,ES:1,SE:1,CH:1,NO:1,IS:1};
  var MAXBOOKS=99,FUNNEL='enoch',PACKED=true;

  function detectFunnel(){
    try{if(window.EB_FUNNEL==='88book'||window.EB_FUNNEL==='ethbible')return window.EB_FUNNEL;}catch(e){}
    try{var p=(window.location&&window.location.pathname)||'';if(p.indexOf('complete-88-book-ethiopian-bible')>-1)return '88book';if(p.indexOf('ethiopian-bible-library')>-1)return 'ethbible';}catch(e){}
    return 'enoch';
  }
  function configure(f){
    FUNNEL=f;
    if(f==='88book'){
      V1=58107866480988;V2=58107866513756;V3=58107866546524;
      TIER={};TIER[V1]=1;TIER[V2]=2;TIER[V3]=3;
      BUMP88=57973361377628;COMP4=58108309471580;MAXBOOKS=99;PACKED=true;
    }else if(f==='ethbible'){
      V1=57784731337052;V2=57784731369820;V3=57784731402588;
      TIER={};TIER[V1]=1;TIER[V2]=2;TIER[V3]=3;TIER[57784731435356]=10;
      BUMP88=57973361377628;COMP4=0;MAXBOOKS=10;PACKED=true; /* 5V stepper: exact bundle first (1/2/3/10), 3-Set stacking for 4-9 */ /* 5V: bump slot = the Enoch single (paid-cart classification parity with the drawer engine, Tim 2026-08-21) */
    }
  }
  configure(detectFunnel());

  var confirmed=null,desired=null,failedTarget=null,revision=0,inFlight=false,failed=null,bootPromise=null,queuedIntents=0,retryAction=null;
  var waiters=[],idleWaiters=[],diagnostics=[],opSeq=0,corrections=0,invalidated=false;
  var channel=null,storageKey='eb_cart_v2_signal',checkoutInFlight=false;
  var attrBusy=false,pendingAttributes={},attributeWaiters=[];

  function root(){var s=window.Shopify||{},r=(s.routes&&s.routes.root)||'/';return r.charAt(r.length-1)==='/'?r:r+'/';}
  function endpoint(path){return root()+path.replace(/^\//,'');}
  function copyMap(src){var out={};Object.keys(src||{}).forEach(function(k){var n=parseInt(src[k],10)||0;if(n>0)out[parseInt(k,10)]=n;});return out;}
  function quantities(cart){var q={};(cart&&cart.items||[]).forEach(function(it){var id=parseInt(it.variant_id,10);q[id]=(q[id]||0)+(parseInt(it.quantity,10)||0);});return q;}
  function tierCount(q){var n=0;Object.keys(TIER).forEach(function(k){n+=(q[k]||0)*TIER[k];});return n;}
  function combo(n){
    n=Math.max(0,Math.min(MAXBOOKS,Math.round(n)));
    /* exact bundle variant first (5V: the 10-set at its own price), then pack if allowed */
    var ex=[];Object.keys(TIER).some(function(id){if(TIER[id]===n){ex.push(parseInt(id,10));return true;}return false;});
    if(ex.length||!PACKED)return ex;
    var q3=Math.floor(n/3),r=n%3,out=[];while(q3-->0)out.push(V3);if(r===1)out.push(V1);else if(r===2)out.push(V2);return out;
  }
  function paid(q){return tierCount(q)>0||(BUMP88&&(q[BUMP88]||0)>0)||(COMP4&&(q[COMP4]||0)>0);}
  function geoCode(){try{var g=JSON.parse(sessionStorage.getItem('eb_geo')||'null');return g&&g.cc?String(g.cc).toUpperCase():'';}catch(e){return '';}}
  function giftTarget(q){
    q=copyMap(q);var gifts={};
    if(!paid(q))return gifts;
    gifts[B_LIB]=1;
    if(FUNNEL==='ethbible'){gifts[B_ALL5_AUD]=1;gifts[B_ALL5_EB]=1;}
    else if(COMP4&&(q[COMP4]||0)>0){gifts[B_ALL5_AUD]=1;gifts[B_ALL5_EB]=1;}
    else if(FUNNEL==='88book'){gifts[B_88]=1;if(BUMP88&&(q[BUMP88]||0)>0){gifts[B_ENO_AUD]=1;gifts[B_ENO_EB]=1;}}
    else{gifts[B_ENO_AUD]=1;gifts[B_ENO_EB]=1;if(BUMP88&&(q[BUMP88]||0)>0)gifts[B_88]=1;}
    var cc=geoCode();if(cc&&FREESHIP[cc])gifts[B_SHIP]=1;
    return gifts;
  }
  function normalize(q){
    q=copyMap(q);
    if(COMP4&&BUMP88&&(q[COMP4]||0)>0)delete q[BUMP88];
    /* V18.1: gift cards are entitlement-driven in the drawer, but their variants are committed
       only once at checkout. Keeping normal cart writes paid-only both lowers Shopify's write
       volume and lets the final one-batch add place every complimentary line before paid lines. */
    BONUSES.forEach(function(id){delete q[id];});
    return q;
  }
  function equal(a,b){a=copyMap(a);b=copyMap(b);var keys={};Object.keys(a).forEach(function(k){keys[k]=1;});Object.keys(b).forEach(function(k){keys[k]=1;});return Object.keys(keys).every(function(k){return (a[k]||0)===(b[k]||0);});}
  function compile(cart,target){
    var updates={},left=copyMap(target),seen={};
    (cart.items||[]).forEach(function(it){var id=parseInt(it.variant_id,10),key=it.key||String(id);if(!seen[id]&&left[id]){updates[key]=left[id];seen[id]=1;delete left[id];}else{updates[key]=0;}});
    Object.keys(left).forEach(function(id){updates[id]=left[id];});
    return updates;
  }
  function record(kind,data){
    var row={t:Date.now(),kind:kind};Object.keys(data||{}).forEach(function(k){row[k]=data[k];});diagnostics.push(row);if(diagnostics.length>40)diagnostics.shift();
  }
  function cartError(kind,op,res,text){
    var e=new Error(kind);e.kind=kind;e.operation=op;e.status=res?res.status:0;e.endpoint=res?res.url:'';
    e.contentType=res?(res.headers.get('content-type')||''):'';e.cfMitigated=res?(res.headers.get('cf-mitigated')||''):'';
    e.requestId=res?(res.headers.get('x-request-id')||res.headers.get('x-shopify-stage')||''):'';e.sample=String(text||'').slice(0,180);return e;
  }
  function parseCart(res,op){
    return res.text().then(function(text){
      var ct=res.headers.get('content-type')||'',cf=res.headers.get('cf-mitigated')||'';
      if(!res.ok)throw cartError((res.status===400||res.status===422)?'business':res.status===409?'conflict':(res.status===429||cf?'challenge':res.status>=500?'server':'http'),op,res,text);
      /* Shopify's Ajax API currently serves valid cart JSON as text/javascript on this storefront. */
      if(cf||(ct.indexOf('json')===-1&&ct.indexOf('javascript')===-1))throw cartError(cf?'challenge':'invalid-response',op,res,text);
      var data;try{data=JSON.parse(text);}catch(e){throw cartError('invalid-json',op,res,text);}
      if(!data||!Array.isArray(data.items)||typeof data.total_price!=='number')throw cartError('invalid-cart',op,res,text);
      return data;
    });
  }
  function transport(path,options,kind){
    var op=++opSeq,url=endpoint(path),started=Date.now();record('request',{op:op,method:(options&&options.method)||'GET',path:path});
    return fetch(url,options).then(function(res){return parseCart(res,op);}).then(function(cart){record('response',{op:op,status:200,ms:Date.now()-started});return cart;},function(err){record('error',{op:op,kind:err.kind||'network',status:err.status||0,ms:Date.now()-started});throw err;});
  }
  function read(){return transport('cart.js',{headers:{Accept:'application/json'}},'read');}
  function update(cart,target){return transport('cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({updates:compile(cart,target)})},'write');}
  function addBatch(items){
    var op=++opSeq,url=endpoint('cart/add.js'),started=Date.now();record('request',{op:op,method:'POST',path:'cart/add.js',purpose:'checkout-order'});
    return fetch(url,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:items})}).then(function(res){
      return res.text().then(function(body){
        var ct=res.headers.get('content-type')||'',cf=res.headers.get('cf-mitigated')||'',data;
        if(!res.ok)throw cartError((res.status===400||res.status===422)?'business':res.status===409?'conflict':(res.status===429||cf?'challenge':res.status>=500?'server':'http'),op,res,body);
        if(cf||(ct.indexOf('json')===-1&&ct.indexOf('javascript')===-1))throw cartError(cf?'challenge':'invalid-response',op,res,body);
        try{data=JSON.parse(body);}catch(e){throw cartError('invalid-json',op,res,body);}
        if(!data||!Array.isArray(data.items))throw cartError('invalid-cart',op,res,body);
        record('response',{op:op,status:200,ms:Date.now()-started,purpose:'checkout-order'});return data;
      });
    },function(err){record('error',{op:op,kind:err.kind||'network',status:err.status||0,ms:Date.now()-started,purpose:'checkout-order'});throw err;});
  }

  function delay(ms){return new Promise(function(resolve){setTimeout(resolve,ms);});}
  function withTimeout(promise,ms,fallback){
    return Promise.race([Promise.resolve(promise),delay(ms).then(function(){return fallback;})]);
  }
  function cartHasLine(cart,item){
    return !!(cart&&cart.items&&(cart.items||[]).some(function(it){
      if(parseInt(it.variant_id,10)!==parseInt(item.id,10))return false;
      if(!item.selling_plan)return true;
      var plan=it.selling_plan_allocation&&it.selling_plan_allocation.selling_plan;
      return !!(plan&&String(plan.id)===String(item.selling_plan));
    }));
  }
  function checkoutRequestedItems(){
    var requested=[];
    try{if(window.EBDrawer&&typeof window.EBDrawer.checkoutItems==='function')requested=window.EBDrawer.checkoutItems()||[];}catch(e){}
    return requested.filter(function(it){return it&&parseInt(it.id,10)>0;});
  }
  function checkoutGiftItems(cart){
    var gifts=giftTarget(quantities(cart));
    return FREE_CHECKOUT_ORDER.filter(function(id){return gifts[id];}).map(function(id){return {id:id,quantity:1};});
  }
  function giftLines(cart){return (cart&&cart.items||[]).filter(function(it){return BONUSES.indexOf(parseInt(it.variant_id,10))>-1;});}
  function giftsAreCanonical(cart,expected){
    var lines=giftLines(cart),ids=expected.map(function(it){return parseInt(it.id,10);});
    if(lines.length!==ids.length)return false;
    if(lines.some(function(it,i){return parseInt(it.variant_id,10)!==ids[i]||(parseInt(it.quantity,10)||0)!==1;}))return false;
    if((cart.items||[]).length<ids.length)return false;
    return ids.every(function(id,i){return parseInt(cart.items[i].variant_id,10)===id;});
  }
  function stripLegacyGifts(cart){
    var target=quantities(cart),had=false;BONUSES.forEach(function(id){if(target[id])had=true;delete target[id];});
    if(!had)return Promise.resolve(cart);
    record('checkout-gift-migration',{status:'start',gifts:giftLines(cart).length});
    return boundedWrite(cart,target).then(read).then(function(next){
      record('checkout-gift-migration',{status:giftLines(next).length?'incomplete':'verified'});return next;
    },function(err){
      record('checkout-gift-migration-error',{kind:err&&err.kind||'network',status:err&&err.status||0});
      return read().catch(function(){return cart;});
    });
  }
  function addCheckoutVisualOrder(base,visualOrder){
    var attempt=0,current=base,backoff=[300,700];
    function allPresent(cart){return visualOrder.every(function(it){return cartHasLine(cart,it);});}
    function inspectOrRetry(err){
      return read().then(function(real){
        current=real;
        if(allPresent(real))return real;
        if(!retryable(err)||attempt>=3){record('checkout-order-retry',{status:'exhausted',attempt:attempt,kind:err&&err.kind||'state-mismatch'});return real;}
        record('checkout-order-retry',{status:'retry',attempt:attempt,kind:err&&err.kind||'state-mismatch'});
        return delay(backoff[Math.min(attempt-1,backoff.length-1)]).then(commit);
      },function(){
        if(!retryable(err)||attempt>=3){record('checkout-order-retry',{status:'read-failed',attempt:attempt,kind:err&&err.kind||'network'});return current;}
        return delay(backoff[Math.min(attempt-1,backoff.length-1)]).then(commit);
      });
    }
    function commit(){
      var additions=visualOrder.filter(function(it){return !cartHasLine(current,it);});
      if(!additions.length)return Promise.resolve(current);
      attempt++;
      /* Shopify renders a multi-add response in reverse request order on this storefront. Submit
         the exact inverse so checkout reads free shipping -> free library/digital gifts ->
         subscription (when selected) -> the older paid cart. */
      return addBatch(additions.slice().reverse()).then(read).then(function(real){
        current=real;
        if(allPresent(real))return real;
        return inspectOrRetry(cartError('state-mismatch',opSeq,null,''));
      },inspectOrRetry);
    }
    return commit();
  }
  function commitCheckoutAdditions(cart){
    var requested=checkoutRequestedItems(),gifts=checkoutGiftItems(cart);
    var missingRequested=requested.filter(function(it){return !cartHasLine(cart,it);});
    /* Existing V18/legacy sessions can already contain gift lines. Reset ONLY those complimentary
       lines when their order is stale, or when a new subscription line would otherwise jump above
       them. Paid books, paid add-ons, protection and selling-plan lines are never rebuilt. */
    var needsGiftReset=giftLines(cart).length>0&&(!giftsAreCanonical(cart,gifts)||missingRequested.length>0);
    var prepared=needsGiftReset?stripLegacyGifts(cart):Promise.resolve(cart);
    return prepared.then(function(base){
      var visualOrder=gifts.concat(requested);
      var additions=visualOrder.filter(function(it){return !cartHasLine(base,it);});
      if(!additions.length)return base;
      return addCheckoutVisualOrder(base,visualOrder).then(function(next){
        var giftsVerified=giftsAreCanonical(next,gifts);
        var requestedVerified=requested.every(function(it){return cartHasLine(next,it);});
        record('checkout-order',{status:(giftsVerified&&requestedVerified)?'verified':'fallback',gifts:gifts.length,requested:requested.length});
        if(missingRequested.length&&missingRequested.every(function(it){return cartHasLine(next,it);})){try{if(window.EBDrawer&&typeof window.EBDrawer.checkoutCommitted==='function')window.EBDrawer.checkoutCommitted(missingRequested);}catch(e){}}
        return next;
      });
    });
  }
  function canonicalizeCheckout(){
    /* Compatibility name retained for existing integrations. V18.1 never clears or reconstructs
       the paid cart. It commits missing gifts once in display order and may migrate only legacy
       complimentary lines; Shopify's last verified non-empty cart always remains the fallback. */
    return read().catch(function(){return confirmed;}).then(function(cart){
      if(!cart||!cart.items||!cart.items.length)throw cartError('empty-checkout',opSeq,null,'');
      if(inFlight||desired||queuedIntents||attrBusy)return cart;
      return commitCheckoutAdditions(cart);
    });
  }
  function redirectToCheckout(cart){
    if(!cart||!cart.items||!cart.items.length)throw cartError('empty-checkout',opSeq,null,'');
    /* Server truth is final at this point, so the transaction lock is no longer protecting a cart
       write. Release it before navigation. This also makes Checkout work immediately after a
       checkout -> Back return even when the browser restores the page without a timely pageshow. */
    confirmed=cart;checkoutInFlight=false;window.__EBD_CHECKOUT_LOCK=false;checkoutReady(true);
    record('checkout',{status:'redirect',items:cart.items.length});window.location.href=endpoint('checkout');return cart;
  }
  function beginCheckout(){
    if(checkoutInFlight)return Promise.resolve(confirmed);
    checkoutInFlight=true;window.__EBD_CHECKOUT_LOCK=true;checkoutReady(false);status('sync','Opening secure checkout…');
    /* A pending update gets a short, hard budget. Reads may overlap a write; a second write may not.
       After the budget, we redirect with server truth as long as the cart contains something. */
    var idle=withTimeout(whenIdle().catch(function(){return confirmed;}),2200,confirmed);
    return idle.then(function(){return withTimeout(canonicalizeCheckout(),4200,confirmed);}).then(redirectToCheckout).catch(function(err){
      return withTimeout(read(),900,confirmed).then(redirectToCheckout).catch(function(finalErr){
        checkoutInFlight=false;window.__EBD_CHECKOUT_LOCK=false;failed=finalErr||err;
        status('error','We could not find a verified item to check out yet.');throw (finalErr||err);
      });
    });
  }

  function checkoutReady(on){var el=document.getElementById('ebd-checkout');if(!el)return;if(on)el.removeAttribute('aria-disabled');else el.setAttribute('aria-disabled','true');}
  function status(mode,message){
    var drawer=document.getElementById('eb-drawer');if(!drawer)return;
    var n=document.getElementById('ebd-v2-status');
    if(!n){n=document.createElement('div');n.id='ebd-v2-status';n.setAttribute('aria-live','polite');n.style.cssText='display:none;padding:9px 16px;border-bottom:1px solid #e3d6b6;background:#FFF8E8;color:#5a4a1f;font:600 13px/1.35 Sen,system-ui,sans-serif';var reward=drawer.querySelector('.ebd-reward');if(reward&&reward.parentNode)reward.parentNode.insertBefore(n,reward.nextSibling);}
    if(mode==='ready'){n.style.display='none';n.innerHTML='';checkoutReady(true);return;}
    n.style.display='block';checkoutReady(false);
    if(mode==='error'){
      n.style.background='#FFF0E5';n.style.color='#6F2D16';n.innerHTML='<span>'+message+'</span> <button type="button" data-ebd-v2-retry style="min-width:64px;min-height:44px;margin-left:8px;border:1px solid currentColor;border-radius:7px;background:transparent;color:inherit;padding:8px 12px;font:700 13px Sen,system-ui,sans-serif;cursor:pointer">Retry</button>';
      if(confirmed&&confirmed.items&&confirmed.items.length)checkoutReady(true);
    }else{n.style.background='#FFF8E8';n.style.color='#5a4a1f';n.textContent=message||'Updating your order…';}
  }
  function renderVerified(cart){confirmed=cart;try{if(window.EBDrawer&&window.EBDrawer.render)window.EBDrawer.render(cart);}catch(e){}if(inFlight||desired)checkoutReady(false);}
  function retryable(err){return !err||!err.status||err.kind==='conflict'||err.kind==='challenge'||err.kind==='server'||err.kind==='invalid-response'||err.kind==='invalid-json'||err.kind==='network';}
  function boundedWrite(base,target){
    var attempt=0,current=base,backoff=[500,1200];
    function verifyOrRetry(err){
      return read().then(function(real){
        current=real;
        if(equal(quantities(real),target))return real;
        if(!retryable(err)||attempt>=3)throw err;
        return delay(backoff[Math.min(attempt-1,backoff.length-1)]).then(commit);
      },function(){
        if(!retryable(err)||attempt>=3)throw err;
        return delay(backoff[Math.min(attempt-1,backoff.length-1)]).then(commit);
      });
    }
    function commit(){
      attempt++;record('commit-attempt',{attempt:attempt});
      return update(current,target).then(function(cart){
        if(equal(quantities(cart),target))return cart;
        return verifyOrRetry(cartError('state-mismatch',opSeq,null,''));
      },verifyOrRetry);
    }
    return commit();
  }
  function broadcast(){try{if(channel)channel.postMessage({type:'cart-changed',source:FUNNEL+'-v2'});localStorage.setItem(storageKey,String(Date.now()));}catch(e){}}
  function publishPaidAdds(before,after){
    var shopify=window.Shopify||{},analyticsApi=shopify.analytics;
    var beforeQ=quantities(before),lines=[],value=0,currency=(after&&after.currency)||'USD';
    (after&&after.items||[]).forEach(function(it){
      var id=parseInt(it.variant_id,10),qty=parseInt(it.quantity,10)||0,added=Math.max(0,qty-(beforeQ[id]||0));
      if(!id||!added)return;
      var lineCents=Number(it.final_line_price),unitCents=qty>0&&isFinite(lineCents)?lineCents/qty:Number(it.final_price!=null?it.final_price:it.price);
      if(!isFinite(unitCents)||unitCents<=0)return;
      var unit=Math.round(unitCents)/100;
      lines.push({id:String(id),variant_id:id,product_title:String(it.product_title||it.title||'Library of Alexandria book'),variant_title:String(it.variant_title||''),quantity:added,item_price:unit});
      value+=unit*added;
    });
    if(!lines.length)return;
    var payload={funnel:FUNNEL,currency:String(currency||'USD'),value:Math.round(value*100)/100,lines:lines,page_location:String((window.location&&window.location.href)||''),event_id:FUNNEL+':'+String(opSeq)+':'+String(Date.now())};
    if(analyticsApi&&typeof analyticsApi.publish==='function'){
      try{
        var receipt=analyticsApi.publish('loa:paid_cart_added',payload);
        if(receipt&&typeof receipt.catch==='function')receipt.catch(function(err){record('analytics-error',{event:'loa:paid_cart_added',message:String(err&&err.message||err||'publish rejected')});});
        record('analytics-publish',{event:'loa:paid_cart_added',value:payload.value,lines:lines.length});
      }catch(err){record('analytics-error',{event:'loa:paid_cart_added',message:String(err&&err.message||err||'publish failed')});}
    }
    try{
      if(window.LOA_KLAVIYO_ATC&&typeof window.LOA_KLAVIYO_ATC.track==='function'){
        record('klaviyo-atc',window.LOA_KLAVIYO_ATC.track(payload));
      }
    }catch(err){record('analytics-error',{event:'Klaviyo Added to Cart',message:String(err&&err.message||err||'bridge failed')});}
  }
  function settleWaiters(ok,value){var list=waiters.splice(0);list.forEach(function(w){if(ok)w.resolve(value);else w.reject(value);});}
  function settleIdle(ok,value){if(queuedIntents||inFlight||desired||attrBusy||Object.keys(pendingAttributes).length)return;var list=idleWaiters.splice(0);list.forEach(function(w){if(ok)w.resolve(value);else w.reject(value);});}
  function flush(){
    if(inFlight||attrBusy||!desired||!confirmed)return;
    var target=copyMap(desired),rev=revision,base=confirmed;
    if(equal(quantities(base),target)){desired=null;failedTarget=null;failed=null;retryAction=null;invalidated=false;status('ready');settleWaiters(true,base);flushAttributes();settleIdle(true,base);return;}
    inFlight=true;failed=null;status('sync','Updating your order…');
    Promise.resolve().then(function(){return boundedWrite(base,target);}).then(function(cart){
      inFlight=false;renderVerified(cart);broadcast();publishPaidAdds(base,cart);
      if(rev!==revision||!equal(quantities(cart),desired)){
        corrections++;if(corrections>2){throw cartError('state-mismatch',opSeq,null,'');}flush();return;
      }
      corrections=0;desired=null;failedTarget=null;failed=null;retryAction=null;invalidated=false;status('ready');settleWaiters(true,cart);flushAttributes();settleIdle(true,cart);
    }).catch(function(err){
      inFlight=false;
      /* Final reconciliation is authoritative. An ambiguous response may have landed; if so, finish
         silently. Otherwise repaint from Shopify truth and retain the intended target for Retry. */
      read().then(function(real){
        confirmed=real;renderVerified(real);
        if(equal(quantities(real),target)){
          desired=null;failedTarget=null;failed=null;retryAction=null;status('ready');broadcast();publishPaidAdds(base,real);settleWaiters(true,real);flushAttributes();settleIdle(true,real);return;
        }
        failedTarget=copyMap(target);desired=null;failed=err;
        var msg=(err&&err.kind==='business')?'Shopify could not apply that selection. The verified order below is what checkout will use.':'That change could not be verified. The order below now matches Shopify exactly.';
        status('error',msg);settleWaiters(false,err);flushAttributes();settleIdle(false,err);
      },function(){
        failedTarget=copyMap(target);desired=null;failed=err;if(confirmed)renderVerified(confirmed);
        status('error','That change could not be verified. Your last server-confirmed order is still available for checkout.');settleWaiters(false,err);flushAttributes();settleIdle(false,err);
      });
    });
  }
  function settleAttributeWaiters(list,ok,value){(list||[]).forEach(function(w){if(ok)w.resolve(value);else w.reject(value);});}
  function flushAttributes(){
    if(attrBusy||inFlight||desired||queuedIntents||!Object.keys(pendingAttributes).length)return;
    var attrs=pendingAttributes,batchWaiters=attributeWaiters;pendingAttributes={};attributeWaiters=[];attrBusy=true;
    transport('cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({attributes:attrs})},'attributes').then(function(cart){
      attrBusy=false;confirmed=cart;record('attributes',{status:'verified',count:Object.keys(attrs).length});settleAttributeWaiters(batchWaiters,true,cart);if(desired)flush();else if(Object.keys(pendingAttributes).length)flushAttributes();settleIdle(true,cart);
    },function(err){
      attrBusy=false;record('attributes-error',{kind:err&&err.kind||'network',status:err&&err.status||0});settleAttributeWaiters(batchWaiters,false,err);if(desired)flush();else if(Object.keys(pendingAttributes).length)flushAttributes();settleIdle(true,confirmed);
    });
  }
  function setAttributes(attrs){
    Object.keys(attrs||{}).forEach(function(k){if(attrs[k]!=null&&attrs[k]!=='')pendingAttributes[k]=String(attrs[k]);});
    if(!Object.keys(pendingAttributes).length)return Promise.resolve(confirmed);
    var p=new Promise(function(resolve,reject){attributeWaiters.push({resolve:resolve,reject:reject});});flushAttributes();return p;
  }
  function bootstrap(){
    if(confirmed&&!invalidated)return Promise.resolve(confirmed);
    if(bootPromise)return bootPromise;
    var shared=(window.EBDrawer&&window.EBDrawer.snapshot&&window.EBDrawer.snapshot());
    if(!invalidated&&shared&&shared.items){confirmed=shared;invalidated=false;return Promise.resolve(shared);}
    bootPromise=((window.EBDrawer&&window.EBDrawer.getCart)?window.EBDrawer.getCart():read()).then(function(c){confirmed=c;invalidated=false;bootPromise=null;return c;},function(){return read().then(function(c){confirmed=c;invalidated=false;bootPromise=null;return c;},function(e){bootPromise=null;throw e;});});
    return bootPromise;
  }
  function queue(makeTarget){
    queuedIntents++;retryAction=function(){return queue(makeTarget);};status('sync','Updating your order…');
    return bootstrap().then(function(){
      queuedIntents--;
      var base=desired?copyMap(desired):quantities(confirmed),next=makeTarget(base)||base;desired=normalize(next);revision++;
      var p=new Promise(function(resolve,reject){waiters.push({rev:revision,resolve:resolve,reject:reject});});flush();return p;
    },function(err){queuedIntents--;failed=err;status('error','We could not verify your cart yet.');settleIdle(false,err);throw err;});
  }
  function replace(items,keep){
    queuedIntents++;retryAction=function(){return replace(items,keep);};status('sync','Updating your order…');
    return bootstrap().then(function(){
      queuedIntents--;
      var cur=quantities(confirmed),next={};
      (items||[]).forEach(function(it){var id=parseInt(it.id,10),q=parseInt(it.quantity,10)||1;if(id&&BONUSES.indexOf(id)===-1)next[id]=(next[id]||0)+q;});
      Object.keys(keep||{}).forEach(function(id){id=parseInt(id,10);if(cur[id]&&!next[id])next[id]=cur[id];});
      desired=normalize(next);revision++;var p=new Promise(function(resolve,reject){waiters.push({rev:revision,resolve:resolve,reject:reject});});flush();return p;
    },function(err){queuedIntents--;failed=err;status('error','We could not verify your order yet.');settleIdle(false,err);throw err;});
  }
  function setTier(n){return queue(function(q){Object.keys(TIER).forEach(function(id){delete q[id];});combo(n).forEach(function(id){q[id]=(q[id]||0)+1;});return q;});}
  function setQty(id,n){return queue(function(q){if(n>0)q[id]=n;else delete q[id];return q;});}
  function addVariant(id){return queue(function(q){if(COMP4&&id===COMP4){q[COMP4]=1;if(BUMP88)delete q[BUMP88];}else if(id)q[id]=1;return q;});}
  function setProtection(on){return setQty(PROTECT,on?1:0);}
  function syncRegion(){return queue(function(q){return q;});}
  function current(){return desired?copyMap(desired):quantities(confirmed);}
  function retry(){if(inFlight||attrBusy||queuedIntents)return;failed=null;if(failedTarget){desired=copyMap(failedTarget);failedTarget=null;revision++;flush();return;}if(desired){flush();return;}if(retryAction){var fn=retryAction;fn().catch(function(){});}}
  function whenIdle(){if(!queuedIntents&&!inFlight&&!desired&&!attrBusy&&!Object.keys(pendingAttributes).length)return Promise.resolve(confirmed);return new Promise(function(resolve,reject){idleWaiters.push({resolve:resolve,reject:reject});});}
  function invalidate(reason){invalidated=true;record('invalidate',{reason:reason||'external'});if(!inFlight&&!desired)bootstrap().then(renderVerified).catch(function(){});}
  function resumeFromHistory(){checkoutInFlight=false;window.__EBD_CHECKOUT_LOCK=false;failed=null;failedTarget=null;invalidated=true;bootstrap().then(renderVerified).catch(function(){});}

  function optimisticTier(n){var b=document.querySelector('#ebd-tq b');if(b)b.textContent=n;}
  function optimisticOther(id,n){var q=document.querySelector('[data-oqty="'+id+'"]');if(q){var b=q.querySelector('b');if(b)b.textContent=n;var line=q.closest('.ebd-line');if(line)line.style.opacity=n?'1':'.35';}}
  function optimisticProtection(on,el){el.classList.toggle('ebd-poff',!on);el.setAttribute('aria-checked',on?'true':'false');var s=el.querySelector('.ebd-pstate');if(s)s.textContent=on?'Protected — free reship if lost or damaged':'Not protected';}
  function handleDrawer(e){
    var drawer=e.target.closest&&e.target.closest('#eb-drawer');if(!drawer)return;
    var t=e.target.closest('[data-ebd-v2-retry],[data-tinc],[data-tdec],[data-ostep],[data-ebd-add],[data-ebd-protect],[data-ebd-gtoggle],[data-ebd-ups-scroll],#ebd-checkout');if(!t)return;
    e.preventDefault();e.stopImmediatePropagation();
    if(t.matches('[data-ebd-v2-retry]')){retry();return;}
    if(t.id==='ebd-checkout'){
      beginCheckout().catch(function(){});return;
    }
    var q=current(),promise=null;
    if(t.matches('[data-tinc],[data-tdec]')){
      var n=tierCount(q)+(t.hasAttribute('data-tinc')?1:-1),other=(BUMP88?(q[BUMP88]||0):0)+(COMP4?(q[COMP4]||0):0);n=Math.max(other?0:1,Math.min(MAXBOOKS,n));optimisticTier(n);promise=setTier(n);
    }else if(t.matches('[data-ostep]')){
      var id=parseInt(t.getAttribute('data-ostep'),10),nq=Math.max(0,(q[id]||0)+(parseInt(t.getAttribute('data-d'),10)||0));
      if(nq===0&&((BUMP88&&id===BUMP88)||(COMP4&&id===COMP4))&&tierCount(q)===0&&!q[id===BUMP88?COMP4:BUMP88])return;
      optimisticOther(id,nq);promise=setQty(id,nq);
    }else if(t.matches('[data-ebd-add]')){
      var addId=parseInt(t.getAttribute('data-ebd-add'),10);t.disabled=true;t.textContent='Adding…';var card=t.closest('.ebd-ups');if(card&&addId===COMP4)card.classList.add('ebd-added');promise=addVariant(addId);
    }else if(t.matches('[data-ebd-protect]')){
      var on=!(q[PROTECT]>0);optimisticProtection(on,t);promise=setProtection(on);
    }else if(t.matches('[data-ebd-ups-scroll]')){var u=drawer.querySelector('.ebd-ups');if(u)u.scrollIntoView({behavior:'smooth',block:'center'});return;}
    else{return;}
    if(promise)promise.catch(function(){});
  }

  document.addEventListener('click',handleDrawer,true);
  try{channel=new BroadcastChannel('eb-cart-v2');channel.onmessage=function(){invalidate('broadcast');};}catch(e){}
  window.addEventListener('storage',function(e){if(e.key===storageKey)invalidate('storage');});
  window.addEventListener('online',function(){if(failed)retry();});
  /* A successful checkout redirect leaves this page while checkoutInFlight is true. Chrome may
     later restore the page from BFCache without delivering pageshow early enough for a customer's
     first click. Clear only the navigation lock as the page is hidden; all cart truth remains on
     Shopify and is reconciled when the page becomes visible again. */
  window.addEventListener('pagehide',function(){checkoutInFlight=false;window.__EBD_CHECKOUT_LOCK=false;});
  document.addEventListener('visibilitychange',function(){if(document.visibilityState==='visible'&&(checkoutInFlight||window.__EBD_CHECKOUT_LOCK))resumeFromHistory();});
  window.addEventListener('pageshow',function(e){if(e.persisted||checkoutInFlight||window.__EBD_CHECKOUT_LOCK)resumeFromHistory();});

  var api={replace:replace,setTier:setTier,setQuantity:setQty,add:addVariant,setProtection:setProtection,setAttributes:setAttributes,syncRegion:syncRegion,retry:retry,whenIdle:whenIdle,beginCheckout:beginCheckout,canonicalizeCheckout:canonicalizeCheckout,invalidate:invalidate,resumeFromHistory:resumeFromHistory,diagnostics:function(){return diagnostics.slice();},state:function(){return {funnel:FUNNEL,confirmed:confirmed,desired:copyMap(desired||{}),failedTarget:copyMap(failedTarget||{}),revision:revision,queuedIntents:queuedIntents,inFlight:inFlight,attributeWrite:attrBusy,checkoutInFlight:checkoutInFlight,failed:failed&&{kind:failed.kind,status:failed.status,message:failed.message}};}};
  window.EBCartV2=api;
  window.EnochCartV2=api;
  bootstrap().catch(function(){});
})();
